import React, { useContext } from "react";
import { Container, TitleContainer } from "./title.styles";
import KaymaLogo from "./kaymo_logo_2020.svg";
import SurveyContext from "../../contexts/SurveyContext";
import CurrentQuestionContext from "../../contexts/CurrentQuestionContext";
import ProgressBar from "./ProgressBar/ProgressBar";

const Title = () => {
  const screens = useContext(SurveyContext).screens;
  const currQuestionIndex = useContext(CurrentQuestionContext)
    .currQuestionIndex;

  return (
    <Container>
      <TitleContainer>
        <img
          src={KaymaLogo}
          alt="kayma"
          style={{ height: "9vh", cursor: "pointer" }}
          onClick={() => window.open("https://kayma.com/all-projects.html")}
        />
        <span>תמונת מצב התנהגותית</span>
      </TitleContainer>
      <ProgressBar
        completed={(currQuestionIndex / (screens.length - 2)) * 100}
      />
    </Container>
  );
};

export default Title;
